import { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { trans } from '@spotahome/soyuz/client';

import BackButton from '../../BackButton';

import DateFilterSwitcher from '../DateFilterSwitcher';

import styles from './DateFilterHeader.module.scss';

const DateFilterHeader = ({
  subtitle = null,
  renderContent = null,
  onClickBack = null,
  onClickSwitcher = null,
  isMonthsFilter = false
}) => {
  const ref = useRef(null);

  useEffect(() => {
    if (ref.current) {
      const paddingTop = parseInt(getComputedStyle(ref.current).paddingTop, 10);
      const style = document.createElement('style');
      style.innerHTML = `
        body {
          --date-filter-header-height: ${
            ref.current.scrollHeight - paddingTop
          }px;
        }`;
      ref.current.appendChild(style);
    }
  }, [ref, isMonthsFilter]);

  return (
    <div className={styles['date-filter-header']} ref={ref}>
      <div className={styles['date-filter-header__title']}>
        {onClickBack && (
          <BackButton
            onClick={onClickBack}
            dataTest="date-range-filter-back-button"
          />
        )}
        <div>
          <h2>{trans('search.exposedfilters.dates.range.title')}</h2>
          {subtitle || null}
        </div>
      </div>
      {onClickSwitcher && (
        <DateFilterSwitcher
          isMonthsFilter={isMonthsFilter}
          onClick={onClickSwitcher}
        />
      )}
      {renderContent ? renderContent() : null}
    </div>
  );
};

DateFilterHeader.propTypes = {
  subtitle: PropTypes.string,
  renderContent: PropTypes.func,
  onClickBack: PropTypes.func,
  onClickSwitcher: PropTypes.func,
  isMonthsFilter: PropTypes.bool
};

export default DateFilterHeader;
